import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { lightSkeletonTheme } from "./skeletonTheme";

// Mirrors ShopDetail.jsx's 3-column layout: thumbnail rail, main photo,
// and the purchase panel (title, price, description, size selects, CTA).
const ShopDetailSkeleton = ({ navHeight }) => {
  return (
    <div
      className="outer-container container"
      style={{ minHeight: navHeight ? `calc(100vh - ${navHeight}px)` : undefined }}
    >
      <SkeletonTheme {...lightSkeletonTheme}>
        <div className="max-w-6xl mx-auto px-3 py-8 grid grid-cols-1 md:grid-cols-[88px_1fr] lg:grid-cols-[88px_1fr_400px] gap-6 lg:gap-8">
          {/* Thumbnail rail */}
          <div className="order-2 md:order-1 flex flex-row md:flex-col gap-3">
            {Array.from({ length: 5 }).map((_, idx) => (
              <Skeleton key={idx} width={76} height={76} borderRadius={12} />
            ))}
          </div>

          {/* Main photo */}
          <div className="order-1 md:order-2">
            <Skeleton className="aspect-square" borderRadius={16} />
          </div>

          {/* Purchase panel */}
          <div className="order-3 md:col-span-2 lg:col-span-1">
            <Skeleton width="60%" height={16} containerClassName="block mb-3" />
            <Skeleton width="40%" height={30} containerClassName="block mb-6" />
            <Skeleton count={2} height={16} containerClassName="block mb-2" />
            <Skeleton count={3} width="85%" height={14} containerClassName="block mb-2 mt-4" />

            <Skeleton width={160} height={16} containerClassName="block mt-6 mb-2" />
            <Skeleton width={120} height={16} containerClassName="block mb-6" />

            <div className="grid grid-cols-2 gap-4">
              <Skeleton height={56} borderRadius={12} />
              <Skeleton height={56} borderRadius={12} />
            </div>
            <Skeleton height={52} borderRadius={12} containerClassName="block mt-6" />
          </div>
        </div>
      </SkeletonTheme>
    </div>
  );
};

export default ShopDetailSkeleton;
